module.exports = __webpack_public_path__ + "static/media/galerija_2017 (32).cfe5f471.jpg";